export const STAGES = [
  "Cutting",
  "Forming",
  "Punching and Shearing",
  "Welding",
  "Machining",
  "Assembling",
  "Finishing",
  "Challan",
  "Receiving to Party",
  "GR (Goods Receipt)",
  "Payment",
  "Custom Work",
];

export const ROLE_LABELS = {
  owner: "Owner",
  manager: "Manager",
  captain: "Captain",
  client: "Client",
};

export const STATUS_META = {
  completed: { label: "Completed", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  in_progress: { label: "In Progress", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  pending_review: { label: "Pending Review", cls: "bg-blue-500/20 text-blue-400 border-blue-500/40" },
  not_started: { label: "Not Started", cls: "bg-slate-500/10 text-slate-400 border-slate-500/30" },
  rejected: { label: "Rejected", cls: "bg-rose-500/15 text-rose-400 border-rose-500/30" },
};

export function jobProgress(job) {
  if (!job?.stages?.length) return 0;
  const done = job.stages.filter((s) => s.status === "completed").length;
  return Math.round((done / job.stages.length) * 100);
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", {
      day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}
